var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"d-flex justify-space-between"},[_c('h2',{staticClass:"page-heading",attrs:{"color":"#6A158E"},domProps:{"textContent":_vm._s(_vm.page_title)}}),_c('bread-crumbs',{attrs:{"items":_vm.breadItems}})],1),_c('div',{staticClass:"nmt-1"},[_c('Form',{attrs:{"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }